import _typeof from "@babel/runtime/helpers/typeof";
import _inherits from "@babel/runtime/helpers/inherits";
import _setPrototypeOf from "@babel/runtime/helpers/setPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _wrapRegExp() { _wrapRegExp = function _wrapRegExp(e, r) { return new BabelRegExp(e, void 0, r); }; var e = RegExp.prototype, r = new WeakMap(); function BabelRegExp(e, t, p) { var o = RegExp(e, t); return r.set(o, p || r.get(e)), _setPrototypeOf(o, BabelRegExp.prototype); } function buildGroups(e, t) { var p = r.get(t); return Object.keys(p).reduce(function (r, t) { var o = p[t]; if ("number" == typeof o) r[t] = e[o];else { for (var i = 0; void 0 === e[o[i]] && i + 1 < o.length;) i++; r[t] = e[o[i]]; } return r; }, Object.create(null)); } return _inherits(BabelRegExp, RegExp), BabelRegExp.prototype.exec = function (r) { var t = e.exec.call(this, r); if (t) { t.groups = buildGroups(t, this); var p = t.indices; p && (p.groups = buildGroups(p, this)); } return t; }, BabelRegExp.prototype[Symbol.replace] = function (t, p) { if ("string" == typeof p) { var o = r.get(this); return e[Symbol.replace].call(this, t, p.replace(/\$<([^>]+)(>|$)/g, function (e, r, t) { if ("" === t) return e; var p = o[r]; return Array.isArray(p) ? "$" + p.join("$") : "number" == typeof p ? "$" + p : ""; })); } if ("function" == typeof p) { var i = this; return e[Symbol.replace].call(this, t, function () { var e = arguments; return "object" != _typeof(e[e.length - 1]) && (e = [].slice.call(e)).push(buildGroups(e, i)), p.apply(this, e); }); } return e[Symbol.replace].call(this, t, p); }, _wrapRegExp.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * Builds the path text from the given path object.
 */
export var buildPathText = function buildPathText(path, entity) {
  var _entity$status$value, _entity$status;
  var status = (_entity$status$value = entity === null || entity === void 0 || (_entity$status = entity.status) === null || _entity$status === void 0 ? void 0 : _entity$status.value) !== null && _entity$status$value !== void 0 ? _entity$status$value : '';
  var length = path.length;
  if (length === 0) {
    return '';
  }
  var title = path[length - 1].title;
  return status ? "".concat(title, " \u2022 ").concat(status) : title;
};
export var getPathUrl = function getPathUrl(entity, path) {
  var _path$link$url, _path, _entity$link;
  return (_path$link$url = (_path = path[path.length - 1]) === null || _path === void 0 || (_path = _path.link) === null || _path === void 0 ? void 0 : _path.url) !== null && _path$link$url !== void 0 ? _path$link$url : entity === null || entity === void 0 || (_entity$link = entity.link) === null || _entity$link === void 0 ? void 0 : _entity$link.url;
};
export var getMainActionUrl = function getMainActionUrl(actions, entity) {
  var _actions$, _entity$link2;
  return (actions === null || actions === void 0 || (_actions$ = actions[0]) === null || _actions$ === void 0 || (_actions$ = _actions$.link) === null || _actions$ === void 0 ? void 0 : _actions$.url) || (entity === null || entity === void 0 || (_entity$link2 = entity.link) === null || _entity$link2 === void 0 ? void 0 : _entity$link2.url);
};
var MS_PER_SECOND = 1e3;
var SECS_PER_MIN = 60;
var SECS_PER_HOUR = SECS_PER_MIN * 60;
var SECS_PER_DAY = SECS_PER_HOUR * 24;
var SECS_PER_WEEK = SECS_PER_DAY * 7;

// This function is a direct copy from https://github.com/formatjs/formatjs-old/blob/master/packages/intl-utils/src/diff.ts
// If the year between 'from' and 'to' is different and there is more than a week between them, the function returns
// 'year' as the unit. This means some notifications display a '1 year ago' even though its 10 days old.
//
// In the below, we have removed the check for 'year' and 'month' as notifications can be at most 30 days old.
export function selectUnit(from) {
  var to = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Date.now();
  var thresholds = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var resolvedThresholds = _objectSpread(_objectSpread({}, DEFAULT_THRESHOLDS), thresholds || {});
  var secs = (+from - +to) / MS_PER_SECOND;
  if (Math.abs(secs) < resolvedThresholds.second) {
    return {
      value: Math.round(secs),
      unit: 'second'
    };
  }
  var mins = secs / SECS_PER_MIN;
  if (Math.abs(mins) < resolvedThresholds.minute) {
    return {
      value: Math.round(mins),
      unit: 'minute'
    };
  }
  var hours = secs / SECS_PER_HOUR;
  if (Math.abs(hours) < resolvedThresholds.hour) {
    return {
      value: Math.round(hours),
      unit: 'hour'
    };
  }
  var days = secs / SECS_PER_DAY;
  if (Math.abs(days) < resolvedThresholds.day) {
    return {
      value: Math.round(days),
      unit: 'day'
    };
  }
  var weeks = secs / SECS_PER_WEEK;
  return {
    value: Math.round(weeks),
    unit: 'week'
  };
}
export var DEFAULT_THRESHOLDS = {
  second: 45,
  // seconds to minute
  minute: 45,
  // minutes to hour
  hour: 22,
  // hour to day
  day: 5 // day to week
};
export var isProduction = function isProduction() {
  return process.env.NODE_ENV === 'production';
};
export var extractIssueKey = function extractIssueKey(link) {
  try {
    var _match$groups$issueKe, _match$groups;
    var issueKeyRx = /*#__PURE__*/_wrapRegExp(/^\/browse\/([a-z0-9\-]+)$/i, {
      issueKey: 1
    });
    var match = issueKeyRx.exec(new URL(link).pathname);
    return (_match$groups$issueKe = match === null || match === void 0 || (_match$groups = match.groups) === null || _match$groups === void 0 ? void 0 : _match$groups.issueKey) !== null && _match$groups$issueKe !== void 0 ? _match$groups$issueKe : undefined;
  } catch (_unused) {
    // Return undefined for invalid URLs
    return undefined;
  }
};

// Generate a new GUID for CommentSessionId when comment starts
export var generateCommentSessionId = function generateCommentSessionId() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0;
    var v = c === 'x' ? r : r & 0x3 | 0x8;
    return v.toString(16);
  });
};